import { FlexLayout, H4 } from '@deity/falcon-ui';
import { Select } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface ConnectionProps {
  isEditable: boolean;
  type: string;
  onChange: (key: string[], val: string) => void;
}
const Connection: FC<ConnectionProps> = ({ isEditable, type, onChange }) => (
  <FlexLayout p="xxl" flexDirection="column">
    <H4 fontWeight="semiBold" fontSize="xl">
      Connection
    </H4>
    <Select
      label="Type"
      sx={{ marginY: 1 }}
      onChange={(val: any) => onChange(['type'], val?.value)}
      options={[{ label: type?.toUpperCase(), value: type }]}
      value={{ label: type?.toUpperCase(), value: type }}
      disabled={!isEditable}
      disableClearable
    />
  </FlexLayout>
);

export default Connection;
